/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 18/02/22
 */

import { chakra } from '@chakra-ui/react';
import React, { forwardRef } from 'react';
import { withDisplayNameRef } from '@/utils/withDisplayName';

type ChakraPathProps = JSX.IntrinsicElements['path'] & {
    pathD: JSX.IntrinsicElements['path']['d'];
};

/**
 * Helper component to allow use of style props on SVG path component
 * without conflicing `d` props
 */
const ChakraSVGPath = chakra(
    forwardRef<SVGPathElement, ChakraPathProps>(
        withDisplayNameRef(
            ({ pathD, ...otherProps }, ref) => <path {...otherProps} d={pathD} ref={ref} />,
            'ChakraSVGPath',
        ),
    ),
);

export default ChakraSVGPath;
